import { render, staticRenderFns } from "./ServicesReservationReceipt.vue?vue&type=template&id=5628fa4a&scoped=true&"
import script from "./ServicesReservationReceipt.vue?vue&type=script&lang=js&"
export * from "./ServicesReservationReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5628fa4a",
  null
  
)

export default component.exports